export function clearSuccess(type: any) {
    if (Array.isArray(type)) {
        const types = type.map((t) =>
            /(.*)_(REQUEST|SUCCESS)/.exec(t) ? t : t + '_SUCCESS'
        )
        return { type: types, success: false }
    } else {
        return {
            type: /(.*)_(REQUEST|SUCCESS)/.exec(type)
                ? type
                : type + '_SUCCESS',
            success: false,
        }
    }
}

export function clearAllSuccess() {
    return { type: '__ALL_SUCCESS__' }
}

export function clearToast(toastIds: number[]) {
    return {
        type: 'CLEAR_TOAST',
        toastIds
    }
}